var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1885_2147",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 80,
    width: 231,
    height: 93
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M242.588 80.5869H12V172.832H242.588V80.5869Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1885_2147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.934 97.683L159.522 97.0273L158.765 98.3891L153.016 108.829L152.31 110.14L153.671 110.746L238.553 148.471L240.823 149.48V135.761L240.016 135.358L160.883 97.6326L160.934 97.683Z",
    fill: "#343334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.386 151.8L150.191 110.847L158.866 95.0107L242.336 134.804V151.8H242.386ZM154.428 109.435L239.36 147.16V136.72L160.178 98.9951L154.428 109.435Z",
    fill: "#343334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.621 144.539L152.259 145.144L152.965 146.455L158.614 156.946L159.37 158.308L160.783 157.652L240.318 120.481L241.125 120.128V106.41L238.856 107.419L153.671 144.589L153.621 144.539Z",
    fill: "#343334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.664 160.274L150.09 144.387L242.537 104.039V121.036L240.873 121.792L158.664 160.223V160.274ZM154.327 145.9L159.976 156.39H160.077L239.562 119.22V108.729H239.41L154.327 145.9Z",
    fill: "#343334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6539 97.683L95.0661 97.0273L95.8226 98.3891L101.572 108.829L102.278 110.14L100.916 110.746L15.9845 148.471L13.7149 149.48V135.761L14.5219 135.358L93.6539 97.6326V97.683Z",
    fill: "#343334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2017 151.801V134.805L95.6713 95.062L104.346 110.899L12.2017 151.801ZM15.2277 136.721V147.161H15.3791L100.16 109.436L94.4105 98.9959H94.3096L15.2277 136.721Z",
    fill: "#343334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.967 144.538L102.329 145.143L101.623 146.454L95.9739 156.945L95.2174 158.306L93.8052 157.651L14.32 120.531L13.513 120.178V106.459L15.7826 107.468L100.967 144.639V144.538Z",
    fill: "#343334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9235 160.275L12 121.087V104.09L104.447 144.438L95.873 160.325L95.9235 160.275ZM15.0261 119.17L94.6122 156.341L100.261 145.85L15.0261 108.73V119.221V119.17Z",
    fill: "#343334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.101 172.48C102.631 172.48 81.9026 151.953 81.9026 126.634C81.9026 101.316 102.581 80.8901 128.101 80.8901C153.621 80.8901 174.299 101.417 174.299 126.735C174.299 152.054 153.57 172.581 128.101 172.581V172.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7009 126.683C81.7009 152.002 102.43 172.579 127.899 172.68H128.05C153.621 172.68 174.4 152.103 174.4 126.683C174.4 101.264 153.671 80.7373 128.101 80.7373C102.53 80.7373 81.7514 101.315 81.7514 126.683H81.7009ZM84.4748 126.683C84.4748 102.828 103.993 83.4608 128.101 83.4608C152.209 83.4608 171.727 102.828 171.727 126.683C171.727 150.539 152.209 169.906 128.101 169.906C103.993 169.906 84.4748 150.539 84.4748 126.683Z",
    fill: "#343334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.101 172.832H127.798C102.329 172.63 81.6 151.952 81.6 126.684C81.6 101.416 102.43 80.5869 128.101 80.5869C153.772 80.5869 174.602 101.265 174.602 126.735C174.602 152.204 153.722 172.832 128.101 172.832ZM128.101 80.8895C102.581 80.8895 81.8522 101.416 81.8522 126.684C81.8522 151.952 102.53 172.429 127.899 172.53H128.05C153.52 172.53 174.249 152.003 174.249 126.735C174.249 101.467 153.57 80.8895 128.101 80.8895ZM128.101 170.109C103.993 170.109 84.3235 150.641 84.3235 126.735C84.3235 102.829 103.943 83.3104 128.101 83.3104C152.259 83.3104 171.878 102.778 171.878 126.684C171.878 150.59 152.259 170.058 128.101 170.058V170.109ZM128.101 83.613C104.144 83.613 84.6261 102.93 84.6261 126.684C84.6261 150.439 104.144 169.756 128.101 169.756C152.057 169.756 171.576 150.439 171.576 126.684C171.576 102.93 152.057 83.613 128.101 83.613Z",
    fill: "#343334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.531 158.862H95.621V94.4565H160.531V158.811V158.862ZM98.6471 155.836H157.504V97.4826H98.6471V155.836Z",
    fill: "#343334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.05 172.175L82.1547 126.683L128.05 81.1406L173.946 126.633L128.05 172.125V172.175ZM86.4416 126.683L128.05 167.939L169.659 126.683L128.05 85.3771L86.4416 126.633V126.683Z",
    fill: "#343334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.05 172.175L82.1547 126.683L128.05 81.1406L173.946 126.633L128.05 172.125V172.175ZM86.4416 126.683L128.05 167.939L169.659 126.683L128.05 85.3771L86.4416 126.633V126.683Z",
    fill: "#343334"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwist);
export default __webpack_public_path__ + "static/media/Twist.934ce66651ca3e4456764db87361b983.svg";
export { ForwardRef as ReactComponent };